import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { BenefitQueueData } from '../types/benefitQueue'

export interface AssignmentQueue {
  assignee: string
  count: number
  /** Present only after the v1 list fetch. Grid counts omit this. */
  data?: BenefitQueueData[]
}

interface ApplicationQueueState {
  assignmentQueuesMap: Record<string, AssignmentQueue>
  assignmentQueues: AssignmentQueue[] // Keep for backward compatibility and iteration
  isLoading: boolean
  error: string | null
}

const initialState: ApplicationQueueState = {
  assignmentQueuesMap: {},
  assignmentQueues: [],
  isLoading: false,
  error: null,
}

const applicationQueueSlice = createSlice({
  name: 'applicationQueue',
  initialState,
  reducers: {
    setAssignmentQueues: (state, action: PayloadAction<AssignmentQueue[]>) => {
      state.assignmentQueues = action.payload
      state.assignmentQueuesMap = action.payload.reduce(
        (acc, queue) => {
          acc[queue.assignee] = queue
          return acc
        },
        {} as Record<string, AssignmentQueue>
      )
      state.isLoading = false
      state.error = null
    },
    addAssignmentQueue: (state, action: PayloadAction<AssignmentQueue>) => {
      state.assignmentQueues.push(action.payload)
      state.assignmentQueuesMap[action.payload.assignee] = action.payload
    },
    resetApplicationQueue: () => initialState,
  },
})

export const {
  setAssignmentQueues,
  addAssignmentQueue,
  resetApplicationQueue,
} = applicationQueueSlice.actions

export default applicationQueueSlice.reducer
